import { gql } from '@apollo/client';
import { useLazyQuery, useQuery } from '@hooks/apollo';

export const GET_REQUISITION = gql`
  query GET_REQUISITION {
    activeRequisition {
      id
      isVIP
      status
      documentsDueDate
      isCompletedDocumentTemplate
       documents {
        id
        status
        documentType
        documentClass
        documentGrouping
        acceptedMimeTypes
        attachments {
          id
          status
          fileName
          reasonForRejection
          storageServiceStatus
        }
      }
      income {
        id
        paymentFrequency
        hasTaxSituation
        employment {
          id
          name
        }
      }
    }
  }
`;

export const useGetDocumentsInfoQuery = (options = {}) => useQuery(GET_REQUISITION, {
  ...options,
});

export const useGetLazyDocumentsQuery = (options = {}) => useLazyQuery(GET_REQUISITION, {
  ...options,
});
